import { useState } from 'react';
import { submitContact } from '../lib/api.js';

export function ContactForm() {
  const [form, setForm] = useState({ name: '', phone: '', email: '', subject: '', message: '' });
  const [status, setStatus] = useState('idle');
  const [error, setError] = useState(null);

  const change = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    setError(null);
    try {
      await submitContact(form);
      setStatus('ok');
      setForm({ name: '', phone: '', email: '', subject: '', message: '' });
    } catch (err) {
      const msg = err?.response?.data?.error?.message || err.message || 'Submission failed';
      setError(msg);
      setStatus('error');
    }
  };

  return (
    <form className="form-grid" style={{ marginTop: 32 }} onSubmit={onSubmit}>
      <div className="field">
        <label htmlFor="cf-name">Your name</label>
        <input id="cf-name" type="text" required value={form.name} onChange={change('name')} disabled={status === 'sending'} />
      </div>
      <div className="field">
        <label htmlFor="cf-phone">Phone</label>
        <input id="cf-phone" type="tel" value={form.phone} onChange={change('phone')} disabled={status === 'sending'} />
      </div>
      <div className="field full">
        <label htmlFor="cf-email">Email</label>
        <input id="cf-email" type="email" required value={form.email} onChange={change('email')} disabled={status === 'sending'} />
      </div>
      <div className="field full">
        <label htmlFor="cf-subject">Subject</label>
        <input id="cf-subject" type="text" value={form.subject} onChange={change('subject')} disabled={status === 'sending'} />
      </div>
      <div className="field full">
        <label htmlFor="cf-message">Message</label>
        <textarea id="cf-message" rows={5} required value={form.message} onChange={change('message')} disabled={status === 'sending'} />
      </div>
      <div className="full" style={{ display: 'flex', gap: 16, alignItems: 'center', flexWrap: 'wrap' }}>
        <button type="submit" className="btn btn-primary" disabled={status === 'sending'}>
          {status === 'sending' ? 'Sending…' : status === 'ok' ? '✓ Message sent' : 'Send message'}
        </button>
        {status === 'ok' && <span style={{ color: 'var(--green-700)', fontSize: 14 }}>Thanks — someone will reply soon.</span>}
        {status === 'error' && <span style={{ color: '#b54033', fontSize: 14 }}>{error}</span>}
      </div>
    </form>
  );
}
